import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { UserBriefInfo, User } from '@spilca/accounting_ts/v1/auth_common/dtos_pb';
import { QUERY_KEYS } from '@monorepo/helpers';
import { TGRPCPromiseReject } from '@monorepo/grpc';
import { REQUEST_TYPES, useGetRequest } from '@monorepo/requests';
import useIsAuthenticated from '../useIsAuthenticated';

const useUser = (): UseQueryResult<
  UserBriefInfo.AsObject | User.AsObject | null,
  TGRPCPromiseReject
> => {
  const { data } = useIsAuthenticated();
  const getUser = useGetRequest(REQUEST_TYPES.GET_USER);

  return useQuery({
    queryKey: [QUERY_KEYS.USER, data?.userId],
    queryFn: ({ queryKey }: { queryKey: Array<string | undefined> }) =>
      getUser(queryKey[1]),
    retry: false,
    staleTime: 10*60*1000,
    gcTime: 2 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: Boolean(data?.userId)
  });
};

export default useUser;
